import script from "./TextInputWithVariables.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextInputWithVariables.vue?vue&type=script&lang=ts&setup=true"

import "./TextInputWithVariables.vue?vue&type=style&index=0&id=4e79edf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e79edf8"]])

export default __exports__